import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "MacShift"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15.7496 21H8.24964C7.42121 21 6.74964 20.3284 6.74964 19.5V12H2.99964C2.69686 11.9984 2.42469 11.815 2.30964 11.535C2.19219 11.2557 2.25433 10.9331 2.46714 10.7175L11.4671 1.71745C11.608 1.57547 11.7997 1.49561 11.9996 1.49561C12.1996 1.49561 12.3913 1.57547 12.5321 1.71745L21.5321 10.7175C21.7449 10.9331 21.8071 11.2557 21.6896 11.535C21.5746 11.815 21.3024 11.9984 20.9996 12H17.2496V19.5C17.2496 20.3284 16.5781 21 15.7496 21ZM4.80714 10.5H7.49964C7.91385 10.5 8.24964 10.8357 8.24964 11.25V19.5H15.7496V11.25C15.7496 10.8357 16.0854 10.5 16.4996 10.5H19.1921L11.9996 3.30746L4.80714 10.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/MacShift.vue"]]);
